enum AllowanceFrequency {
  Monthly,
  Quarterly,
  Annual,
}

export type AllowanceFrequencyType = {
  id: number
  name: string
}

export let frequencies: AllowanceFrequencyType[] = [
  { id: AllowanceFrequency.Monthly, name: 'Monthly' },
  { id: AllowanceFrequency.Quarterly, name: 'Quarterly' },
  { id: AllowanceFrequency.Annual, name: 'Annual' },
]

export default AllowanceFrequency
